import { defineQuery } from '@rocicorp/zero';
import * as z from 'zod';
import { applyCursor } from '../util/apply-cursor.js';
import { zql } from '../zero-schema.gen.js';
import { Cursor, Sort } from './util.js';
export const ListOrganisationUsersInput = z.object({
    organisationId: z.string(),
    cursor: Cursor.extend({
        createdAt: z.number(),
    }).optional(),
    sort: Sort.extend({
        field: z.enum(['createdAt', 'username']),
    }),
    limit: z.number().optional(),
    filters: z
        .object({
        search: z.string().optional(),
        active: z.boolean().optional(),
    })
        .optional(),
});
export const organisationUsers = {
    listOrganisationUsers: defineQuery(ListOrganisationUsersInput, params => {
        const input = params.args;
        let q = zql.organisationUser.where('organisationId', '=', input.organisationId).where('deletedAt', 'IS', null);
        if (input.filters?.active !== undefined) {
            q = q.where('active', '=', input.filters.active);
        }
        if (input.filters?.search?.trim()) {
            const term = `%${input.filters.search.trim()}%`;
            q = q.where(({ or, cmp }) => or(cmp('email', 'ILIKE', term), cmp('firstName', 'ILIKE', term), cmp('lastName', 'ILIKE', term)));
        }
        q = applyCursor(q, { cursor: input.cursor, sort: input.sort, limit: input.limit });
        return q;
    }),
};
//# sourceMappingURL=organisation-user.queries.js.map